import { SPRINT_OUTCOMES_FEATURE_FLAG } from 'featureFlags/config';
import { useFeatureFlag, useParticipantsFeatureFlag } from 'featureFlags/hooks';

import { USER_MODES } from 'features/user/config';
import { useUserMode } from 'features/user/hooks';

export const useOutcomesFFEnabled = () => {
  const userMode = useUserMode();
  const participantRoutinesEnabled = useParticipantsFeatureFlag(
    SPRINT_OUTCOMES_FEATURE_FLAG
  );
  const myRoutinesEnabled = useFeatureFlag(SPRINT_OUTCOMES_FEATURE_FLAG);

  if (userMode === USER_MODES.dashboard) {
    return myRoutinesEnabled;
  }

  return participantRoutinesEnabled;
};
